<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormOrdenesCompra" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Folio</th>
                            <th :class="StyleTh">Requisicion</th>
                            <th :class="StyleTh">Proveedor</th>
                            <th :class="StyleTh">Fecha de Entrega</th>
                            <th :class="StyleTh">Acciones</th>
                        </template>
                        <template slot="body">
                            <tr v-for="(lista,index) in OrdenesCompra" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					            <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                                <td><p :class="StyleTd">{{ lista.requisiciones.Folio }}</p></td>
                                <td><p :class="StyleTd">{{ lista.Proveedor }}</p></td>
                                <td><p :class="StyleTd">{{ FormatoFecha(lista.FechaEntrega) }}</p></td>
                                <td>
                                    <button @click="SeleccionarOrdenCompra(lista)" type="button" v-b-tooltip.hover.Top title="Seleccionar Requisicion" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle"></i> Agregar</button>
                                </td>
                            </tr>
                            <CSinRegistros :pContIF="OrdenesCompra.length" :pColspan="6"></CSinRegistros>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormOrdenCompra',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Ordenes de Compra Autorizadas',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            OrdenesCompra:[]
        }
    },
    methods: {
        Recuperar(){
            this.ConfigLoad.ShowLoader=true;
            this.$http.get("ordenCompra",{
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    Estatus:'Autorizado'
                }
            }).then((res)=>{
                this.OrdenesCompra=res.data.data.data;
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        SeleccionarOrdenCompra(item){
            this.bus.$emit('SeleccionarOrdenCompra',item);
        },
        FormatoFecha(Fecha){
            var FechaF=new Date(Fecha);
            FechaF=FechaF.toLocaleDateString("es-MX",{day:'numeric',month:'long',year:'numeric'});
            return FechaF;
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.poBtnSave.DisableBtn = false;
            this.Recuperar();
        });
    },
}
</script>

<style>

</style>